<template>
  <div class="product">
    <el-row :gutter="12" class="product__content">
      <el-col :span="colSpan" v-for="item in list" :key="item.id">
        <div class="product__content--img">
          <div class="hover-effect" @click="goProductInfo(item)">
            <img :src="imgURL + item.coverPic.path" :alt="item.coverPic.name" />

            <div class="text">
              <p class="more">view more</p>
            </div>
          </div>
          <p class="name">/ {{ item.name }} /</p>
        </div>
      </el-col>
    </el-row>

    <div class="w-100 pb-40">
      <Pagination
        :needPage="true"
        :total="total"
        :page="listQuery.page"
        @choosePage="choosePage"
        @works_prev="works_prev"
        @works_next="works_next"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
export default {
  components: { Pagination },
  data() {
    return {
      imgURL: process.env.VUE_APP_BASE_IMG_URL,
      colSpan: 8,
      groupTypeId: "",
      total: 0,
      listQuery: {
        GraduateId: this.$route.params.id,
        GroupTypeId: this.$route.query.groupTypeId,
        page: 1,
        limit: 9,
      },
      list: [],
    };
  },
  watch: {
    $route: function (to, from) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  methods: {
    choosePage(number) {
      this.listQuery.page = number;
      this.getCreativeList();
    },
    works_prev(page) {
      this.listQuery.page = page;
      this.getCreativeList();
    },
    works_next(page) {
      this.listQuery.page = page;
      this.getCreativeList();
    },
    goProductInfo(item) {
      this.$router.push({
        name: "productIntro",
        params: { id: item.id },
        query: {
          year: this.$route.query.year,
          GraduateId: this.$route.params.id,
          GroupTypeId: this.$route.query.groupTypeId,
        },
      });
    },
    async getCreativeList() {
      await this.$api.getGraduateExhibit(this.listQuery).then((res) => {
        const { code, data, count } = res.data;
        if (code === 200) {
          this.list = data;
          this.total = Math.ceil(count / this.listQuery.limit);
          document.documentElement.scrollTop = 0;

          this.list.forEach((item, index) => {
            try {
              this.list[index].coverPic = JSON.parse(item.coverPic);
            } catch {
              console.log(error);
            }
          });
        }
      });
    },
    async getGroupList() {
      await this.$api.getGroupTypeList().then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.groupTypeId = data.find((item) => item.name === "創作組").dtCode;
        }
      });
    },
    getScreenWidth() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth > 1200) {
        this.colSpan = 8;
      } else {
        this.colSpan = 12;
      }
    },
  },
  async mounted() {
    await this.getGroupList();
    await this.getCreativeList();
    this.getScreenWidth();
    window.addEventListener("resize", this.getScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getScreenWidth);
  },
};
</script>

<style lang='scss'>
.product {
  width: 100%;
  text-align: center;
  padding: 0 12px;
  @media (min-width: 1024px) {
    padding: 0 120px;
  }

  &__content {
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;

    @media (min-width: 1024px) {
      padding: 0 90px;
    }
    &--img {
      width: 100%;
      position: relative;
      margin-bottom: 12px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      @media (min-width: 1024px) {
        margin-bottom: 40px;
        overflow: hidden;
      }
      .name {
        color: #fff;
        font-weight: bold;
        font-size: 14px;
        line-height: 160%;
        @media (min-width: 768px) {
          font-size: 18px;
        }
      }

      .hover-effect {
        height: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
        @media (min-width: 768px) {
          height: 200px;
        }
        @media (min-width: 1024px) {
          height: 200px;
        }
        @media (min-width: 1440px) {
          height: 240px;
        }
        @media (min-width: 2560px) {
          height: 360px;
        }

        img {
          width: 100%;
          height: 100%;
          -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
          transition: opacity 0.35s, transform 0.35s;
        }

        .text {
          &::before,
          &::after {
            position: absolute;
            content: "";
            opacity: 0;
          }

          &::before {
            top: 40px;
            right: 20px;
            bottom: 40px;
            left: 20px;
            border-top: 1px solid #fff;
            border-bottom: 1px solid #fff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
            -webkit-transform-origin: 0 0;
            transform-origin: 0 0;
          }

          &::after {
            top: 15px;
            right: 50px;
            bottom: 15px;
            left: 50px;
            border-right: 1px solid #fff;
            border-left: 1px solid #fff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
            -webkit-transform-origin: 100% 0;
            transform-origin: 100% 0;
          }

          .more {
            color: #fff;
            position: absolute;
            padding: 8px 24px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -100%);
            background-color: #ceb87f;
            box-shadow: 1px 1px 3px #fff;
            border-radius: 40px;
            text-transform: none;
            opacity: 0;
          }

          p {
            -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
            transition: opacity 0.35s, transform 0.35s;
          }
        }
        @media (min-width: 1024px) {
          &:hover {
            cursor: pointer;

            img {
              filter: brightness(0.5);
              transform: scale(1.2) !important;
              transition: 0.3s;
              opacity: 0.7;
              -webkit-transform: translate3d(0, 0, 0);
              transform: translate3d(0, 0, 0);
            }

            .text {
              &::before,
              &::after {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1);
                transition: 0.3s;
              }

              .more {
                opacity: 1;
              }
            }

            p {
              opacity: 1;
            }

            .text::after,
            p {
              -webkit-transition-delay: 0.15s;
              transition-delay: 0.15s;
            }
          }
        }
      }
    }
  }
}
</style>